/* mk-size-guide.js — split out of mk-sections.js; loaded only by the sections that render it. */

/* ---- Size guide ----------------------------------------------------------- */
/* The button opens the native <dialog> modally (Escape and focus return are
   native); the X and a click on the backdrop close it. */
class MkSizeGuide extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-mk-size-guide-open]');
    this.dialog = this.querySelector('[data-mk-size-guide-dialog]');
    if (!this.button || !this.dialog) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.button.addEventListener('click', () => this.dialog.showModal(), { signal });
    this.querySelector('[data-mk-size-guide-close]')?.addEventListener('click', () => this.dialog.close(), { signal });
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    }, { signal });
    this.dialog.addEventListener('close', () => this.button.focus(), { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

customElements.get('mk-size-guide') || customElements.define('mk-size-guide', MkSizeGuide);
